/**
 * Le navigateur sait-il décoder l'AVIF ? Une seule réponse par page, mémorisée.
 *
 * Pourquoi on le demande (feature 0067) : la galerie offre ses photos en `<picture>`, AVIF d'abord, WebP
 * en repli. Le navigateur choisit seul entre les deux… sauf pour ce que NOUS préchauffons à la main
 * (`imageWarm.ts`, la photo de la couleur d'à côté) : un `new Image()` n'a pas de `<source>`, il prendrait
 * le WebP, et la galerie demanderait ensuite l'AVIF — la même photo deux fois. D'où cette sonde : on
 * préchauffe le format que la galerie utilisera vraiment.
 *
 * La sonde est une image AVIF de 2×2 pixels générée par libvips (aucune donnée tierce), décodée une fois.
 * Sans `Image` (SSR, tests) : « non », et le préchauffage reste en WebP, ce qui est toujours juste.
 */
const PROBE = 'data:image/avif;base64,AAAAHGZ0eXBhdmlmAAAAAG1pZjFhdmlmbWlhZgAAANZtZXRhAAAAAAAAACFoZGxyAAAAAAAAAABwaWN0AAAAAAAAAAAAAAAAAAAAACJpbG9jAAAAAERAAAEAAQAAAAAA+gABAAAAAAAAACAAAAAjaWluZgAAAAAAAQAAABVpbmZlAgAAAAABAABhdjAxAAAAAA5waXRtAAAAAAABAAAAVmlwcnAAAAA4aXBjbwAAAAxhdjFDgQAMAAAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAABZpcG1hAAAAAAAAAAEAAQOBAgMAAAAobWRhdBIACggYADbICGg0IDISHEeHhd3AACwAAACQNY48fohQ';
const PROBE_TIMEOUT_MS = 2000;
let verdict = null;
export function avifSupported() {
    if (verdict)
        return verdict;
    verdict = new Promise((resolve) => {
        if (typeof Image === 'undefined') {
            resolve(false);
            return;
        }
        const probe = new Image();
        // Un décodeur qui ne répond jamais (navigateur exotique, `Image` doublé dans un test) ne doit pas
        // bloquer le préchauffage : passé ce délai, la réponse est « non » et le WebP fait l'affaire.
        const giveUp = setTimeout(() => resolve(false), PROBE_TIMEOUT_MS);
        probe.onload = () => {
            clearTimeout(giveUp);
            resolve(probe.width > 0);
        };
        probe.onerror = () => {
            clearTimeout(giveUp);
            resolve(false);
        };
        probe.src = PROBE;
    });
    return verdict;
}
/** Remise à zéro — les tests seulement. */
export function resetAvifSupport() {
    verdict = null;
}
//# sourceMappingURL=avifSupport.js.map